import React from "react";
import { DgaTag } from "platformscode-new-react";
import { useNavigate } from "react-router-dom";
import Card from "./Card";

export const EServiceCardHome = ({ data }) => {
  const navigate = useNavigate();

  const handleServiceClick = () => {
    navigate(`/service-details/${data.id}`);
  };

  const renderTag = () => {
    if (!data.tag) return null;

    let variant = "neutral";
    if (data.tag === "خدمات الأفراد") variant = "neutral";
    else if (data.tag === "خدمات الأعمال") variant = "neutral";
    else if (data.tag === "خدمات الجهات الحكومية") variant = "neutral";

    return <DgaTag label={data.tag} size="lg" variant={variant} />;
  };

  const resolveUrl = (url) => {
    if (!url) return url;
    if (url.startsWith("#/")) return url.slice(1);
    return url;
  };

  const serviceUrl = resolveUrl(data.url);
  const isServiceAvailable = data.url && data.url !== "غير متوفر";
  const openInSameTab = data.esrvc_url_same === "yes";

  return (

    <>

      <Card
        style={{ height: "340px" }}

        title={data.title}
        description={data.description || ""}
        icon={data.icon}
        image={data.image || ""}
        imageWidth={data.imageWidth || ""}
        imageHeight={data.imageHeight || ""}

        //primary button
        primaryActionLabel="ابدأ الخدمة"
        primaryTrailIconType="link-square-02"
        showPrimaryAction={isServiceAvailable}
        linkPrimaryAction={serviceUrl}
        showPrimaryIcon={data.es_url_is_extarnal === "yes"}



        //secondary button
        secondaryActionLabel="المزيد"
        linkSecondaryAction={handleServiceClick}
        showSecondaryAction={true}
        external
        buttonColor="primary-brand"
        tagLable={data.tag}
        onClick={() => navigate(serviceUrl)}
      />

      {/*       
      <DgaCard
        ref={cardRef}
        style={{ margin: "4px" }}
        cardTitle={data.title}
        description={data.description}
        secondaryActionLabel="المزيد"
        primaryActionLabel={isServiceAvailable ? "ابدأ الخدمة" : "غير متوفر"}
        onPrimaryAction={
          isServiceAvailable
            ? () => window.open(data.url, openInSameTab ? "_self" : "_blank")
            : undefined
        }
        primaryActionDisabled={!isServiceAvailable}
        onSecondaryAction={handleServiceClick}
        featuredIcon={{
          name: data.icon || "alert-circle",
          color: "#067647",
          type: "rounded",
          variant: "stroke",
          size: 21.49,
        }}
        type="default"
        showFeaturedIcon={true}
        effect="stroke"
      >
        <div className="flex gap-3">{renderTag()}</div>
      </DgaCard> */}



    </>

  );
};